module.exports = __webpack_public_path__ + "static/media/medtronic.17cdaf16.png";